// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 9746); hand-edits allowed (see docs/architecture.md)

/** `this.ACHIEV_PRISE_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_ACHIEV_PRISE_DEF(): any {
  return {
    "career": {
      "prise": "gold",
      "amount": [0, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 7000, 8000, 10000]
    },
    "missions": {
      "prise": "gold",
      "amount": [0, 1500, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 15000, 20000]
    },
    "survival": {
      "prise": "gold",
      "amount": [0, 2000, 3000, 4000, 5000, 7000, 10000, 12000, 14000, 16000, 20000, 24000, 28000, 32000, 36000, 40000]
    },
    "boss": {
      "prise": "diam",
      "amount": [0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 4, 4, 4, 5]
    },
    "assault": {
      "prise": "gold",
      "amount": [0, 3000, 6000, 10000, 20000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000, 2000000, 4000000, 8000000]
    },
    "no_death": {
      "prise": "gold",
      "amount": [0, 1000, 2000, 4000, 8000, 15000, 30000, 50000, 70000, 100000, 150000, 200000, 300000, 500000, 1000000, 2000000]
    },
    "no_injure": {
      "prise": "gold",
      "amount": [0, 1500, 3000, 6000, 10000, 20000, 40000, 100000, 200000, 500000, 1000000, 1500000, 2000000, 2500000, 3000000, 4000000]
    },
    "kill_p": {
      "prise": "gold",
      "amount": [0, 1000, 2000, 4000, 10000, 20000, 50000, 100000, 150000, 200000, 300000, 500000, 1000000, 2000000, 3000000, 4000000]
    },
    "kill_e": {
      "prise": "gold",
      "amount": [0, 1000, 2000, 4000, 10000, 20000, 50000, 100000, 150000, 200000, 300000, 500000, 1000000, 2000000, 3000000, 4000000]
    },
    "kill_a": {
      "prise": "gold",
      "amount": [0, 1000, 2000, 4000, 10000, 20000, 50000, 100000, 150000, 200000, 300000, 500000, 1000000, 2000000, 3000000, 4000000]
    },
    "kill_c": {
      "prise": "gold",
      "amount": [0, 1000, 2000, 4000, 10000, 20000, 50000, 100000, 150000, 200000, 300000, 500000, 1000000, 2000000, 3000000, 4000000]
    },
    "kill_h": {
      "prise": "gold",
      "amount": [0, 1000, 2000, 4000, 10000, 20000, 50000, 100000, 150000, 200000, 300000, 500000, 1000000, 2000000, 3000000, 4000000]
    },
    "kill_f": {
      "prise": "gold",
      "amount": [0, 1000, 2000, 4000, 10000, 20000, 50000, 100000, 150000, 200000, 300000, 500000, 1000000, 2000000, 3000000, 4000000]
    },
    "kill_l": {
      "prise": "gold",
      "amount": [0, 1000, 2000, 4000, 10000, 20000, 50000, 100000, 150000, 200000, 300000, 500000, 1000000, 2000000, 3000000, 4000000]
    },
    "para": {
      "prise": "gold",
      "amount": [0, 2000, 3000, 5000, 10000, 15000, 20000, 40000, 80000, 150000, 250000, 400000, 700000, 1000000, 2000000, 3000000]
    },
    "annih": {
      "prise": "diam",
      "amount": [0, 1, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 23, 26, 29, 35]
    },
    "recipes": {
      "prise": "exp",
      "amount": [0, 2, 5, 8, 10, 12, 15, 18, 20, 30, 40, 50, 75, 100, 125, 150]
    },
    "stims": {
      "prise": "exp",
      "amount": [0, 5, 8, 10, 12, 15, 18, 20, 22, 25, 30, 35, 40, 45, 50, 75]
    },
    "buys": {
      "prise": "exp",
      "amount": [0, 1, 3, 5, 8, 10, 12, 15, 20, 25, 30, 35, 40, 45, 50, 100]
    },
    "steal": {
      "prise": "exp",
      "amount": [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300]
    },
    "crafted": {
      "prise": "exp",
      "amount": [0, 3, 6, 9, 15, 20, 25, 30, 35, 40, 45, 50, 75, 100, 125, 150]
    },
    "upgraded": {
      "prise": "exp",
      "amount": [0, 2, 4, 6, 8, 10, 20, 30, 40, 50, 75, 100, 125, 150, 175, 200]
    },
    "wins": {
      "prise": "exp",
      "amount": [0, 5, 8, 10, 12, 15, 25, 35, 50, 75, 100, 125, 150, 200, 250, 300]
    },
    "days": {
      "prise": "diam",
      "amount": [0, 20, 40, 60, 80, 100, 150, 200, 250, 300, 400, 500, 600, 700, 800, 1000]
    }
  };
}
